import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FormArgument } from '@/models/ec-setting'

const EC_ACCOUNT_URL = '/rest/es/crmaccountsetting/getByUser'
const POST_EC_ACCOUNT_URL = '/rest/es/crmaccountsetting/post'
const EC_CHANNEL_SOURCE = '/rest/es/crmchannelsource/syncEcV2ChannelSource'
const EC_FIELD_SELECT = '/rest/es/crmstaticfield/listByCrmCode'

export default {
  getEcAccount ({crmCode}, cb) {
    http.get(EC_ACCOUNT_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  addEcAccount (form, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(POST_EC_ACCOUNT_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getEcSource (cb) {
    http.get(EC_CHANNEL_SOURCE).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getEcFieldSelect ({crmCode}, cb) {
    http.get(EC_FIELD_SELECT, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/ec-setting.js